export const getCashOutAmountParam = (lookingTo, cashOutAmount) =>
  lookingTo === "RefinanceAndCashOut" && cashOutAmount ? cashOutAmount : "0";
